<template>
  <div class="flex flex-wrap gap-x-6 gap-y-3">
    <div class="mt-3.5 typo-label-md sm:mt-3 sm:typo-label-lg">
      {{ $t('filter') }}
    </div>
    <ul v-animate-children-in-from-left class="flex flex-wrap gap-x-3 gap-y-2">
      <li v-for="category in categories" :key="category?.id">
        <button
          :class="filter?.category === category?.slug ? 'bg-blue-500 text-white hover:bg-blue-600':`
            bg-grey-100
            hover:bg-grey-200
          `"
          class="rounded px-4 py-2 transition-colors typo-button-text-xl"
          type="button"
          @click="onFilterCategory(category?.slug || '')"
        >
          {{ category?.title }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { ComponentsMainOverviewBlogFragment } from '#gql'
import type { FilterType } from '~/components/components-main/OverviewBlog.vue'

withDefaults(
  defineProps<{
    categories: ComponentsMainOverviewBlogFragment['blog_categories']
  }>(),
  {
    categories: () => [],
  },
)

const filter = defineModel<FilterType>()

function onFilterCategory(slug: string) {
  if (!filter.value) {
    return
  }

  if (filter.value.category === slug) {
    filter.value.category = null
    return
  }

  filter.value.category = slug
}
</script>
